const merchandiseProductsContainerElement = document.querySelector('.merchandize__products-featured-grid');

if (merchandiseProductsContainerElement) {
  const merchandiseProductsInfoElements = merchandiseProductsContainerElement.querySelectorAll('.product-item__info');

  if (merchandiseProductsInfoElements) {
    const calculateInfoBlockHeight = () => {
      const merchandiseProductsInfoElements = merchandiseProductsContainerElement.querySelectorAll('.product-item__info');
      const info1Element = merchandiseProductsInfoElements[0];
      const info3Element = merchandiseProductsInfoElements[2];
      const info1ElementHeight = info1Element.clientHeight;
      const info3ElementHeight = info3Element.clientHeight;
      const isActualWidth = window.innerWidth >= 1400;

      if (info3ElementHeight > info1ElementHeight && isActualWidth) {
        info1Element.setAttribute('style', `height:${info3ElementHeight}px`);
      } else if (info3ElementHeight < info1ElementHeight || !isActualWidth) {
        info1Element.setAttribute('style', `height:auto`);
      }
    }

    window.addEventListener('resize', calculateInfoBlockHeight);

    calculateInfoBlockHeight();
  }
}
